import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Users, Mail } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Motion";
import { fetchFaculty } from "../lib/api";

const initialsBg = ["#87CEEB", "#6B9AC4", "#0F172A", "#475569"];

const Faculty = () => {
  const [faculty, setFaculty] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetchFaculty()
      .then(setFaculty)
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <div data-testid="faculty-page">
      <PageHeader
        kicker="Faculty"
        title="Educators with industry roots and student outcomes at heart."
        subtitle="Heritage is assembling a faculty of practitioners and academics committed to mentorship and career-focused teaching."
      />

      <section className="hccbt-container section pt-0">
        {loaded && faculty.length === 0 ? (
          <Reveal>
            <div
              className="card-soft p-10 md:p-14 text-center max-w-3xl mx-auto"
              data-testid="faculty-empty-state"
            >
              <motion.div
                initial={{ scale: 0.85, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="w-14 h-14 rounded-full bg-[#87CEEB]/25 mx-auto flex items-center justify-center text-[#0F172A]"
              >
                <Users size={22} />
              </motion.div>
              <span className="overline mt-6 block">Coming soon</span>
              <h2 className="font-display text-3xl md:text-4xl mt-3 text-[#0F172A] leading-tight">
                Our founding faculty is being assembled.
              </h2>
              <p className="mt-5 text-[#475569] leading-relaxed">
                We are carefully selecting practitioners and academics for our
                Diploma in Business Management. Faculty announcements will be
                shared ahead of our first intake.
              </p>
              <div className="mt-8 flex flex-wrap gap-3 justify-center">
                <Link to="/contact" className="btn-primary" data-testid="faculty-stay-updated">
                  <Mail size={16} /> Stay updated
                </Link>
                <Link to="/programs" className="btn-secondary">View programs</Link>
              </div>
            </div>
          </Reveal>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {faculty.map((f, i) => (
              <motion.article
                key={f.id}
                whileHover={{ y: -6 }}
                className="card-soft card-lift p-7"
                data-testid={`faculty-${f.id}`}
              >
                <div
                  className="w-16 h-16 rounded-full flex items-center justify-center font-display text-xl"
                  style={{
                    background: initialsBg[i % initialsBg.length],
                    color: i % initialsBg.length >= 2 ? "#FDFBF7" : "#0F172A",
                  }}
                  aria-hidden
                >
                  {f.initials}
                </div>
                <h3 className="font-display text-xl mt-5 text-[#0F172A] leading-snug">{f.name}</h3>
                <p className="text-sm font-semibold text-[#6B9AC4] mt-1">{f.title}</p>
                <p className="text-sm text-[#475569] mt-4 leading-relaxed">{f.bio}</p>
              </motion.article>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default Faculty;
